import styled from 'styled-components';

import { muiPalette } from '@/shared/general-theme';

export const StyledErrorContainer = styled.div`
    color: ${muiPalette.error.main};
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    text-align: left;
    margin: 0.188rem 0 0 0.875rem;
`;